/* istanbul ignore file */

//TODO: fix test coverage

import React from 'react';

import { Loading } from 'src/components/atoms/Loading/Loading';
import { SignInToContinue } from 'src/components/molecules/SignInToContinue/SignInToContinue';
import { PartnerApplication } from 'src/components/organisms/PartnerApplication/PartnerApplication';
import { RegisterInterest } from 'src/components/organisms/RegisterInterest/RegisterInterest';
import type { SignupProps } from 'src/components/organisms/Signup/Signup';
import { getFeatureFlags, IS_CLIENT } from 'src/settings';
import { useUser } from './hooks/useUser';

const PartnerApplicationApp = (props: SignupProps) => {
  const user = useUser();

  switch (user.status) {
    case 'logged-in':
      return <PartnerApplication {...props} />;
    case 'logged-out':
      return <SignInToContinue />;
    default:
      return <Loading />;
  }
};

export const PartnerSignUp = (props: SignupProps) => {
  const [forceApplication] = React.useState(
    () => IS_CLIENT && window.localStorage.getItem('forceApplication'),
  );

  return forceApplication || getFeatureFlags().signUpEnabled ? (
    <PartnerApplicationApp {...props} />
  ) : (
    <RegisterInterest />
  );
};
